module.exports = __webpack_public_path__ + "static/LTUnivers-BasicRegular-ad1ed4151d57c51acd77cef13914a300.woff";